import SSO from '@percent/admin-dashboard/common/assets/images/moduleLogos/sso.svg'
import { moduleTitles } from '@percent/admin-dashboard/constants/moduleInformation'
import { PartnerScopes } from '@percent/admin-dashboard/constants/scopes'
import DonationLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/donation.svg'
import OrganisationLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/organisation.svg'
import DonationSessionLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/donation_session.svg'
import ValidationRequestLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/validation_request.svg'
import WebhookSubscriptionLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/webhook_subscription.svg'
import AgentVerificationLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/agent_verification.svg'
import ActivityCheckLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/activity_check.svg'
import MonitoringSubscriptionLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/monitoring_subscription.svg'
import EligibilitySubscriptionLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/eligibility_subscription.svg'
import ValidationInviteLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/validation_invite.svg'
import CodeRedemptionLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/code_redemption.svg'
import SingleValidationSubmissionLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/single_validation_submission.svg'
import MonetaryVerificationLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/monetary_verifications.svg'
import ScimLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/scim_api.svg'
import GrantsLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/grants.svg'
import PartnerInsightsLogo from '@percent/admin-dashboard/common/assets/images/moduleLogos/partner_insights.svg'
import styles from './PartnerModuleListTable.module.scss'

export enum ModuleType {
  DISBURSEMENTS = 'Disbursements',
  GRANTS = 'Grants',
  WORKPLACE_GIVING = 'Workplace Giving',
  VERIFICATIONS_INDIVIDUAL_API = 'Verifications (Individual APIs)',
  VALIDATION_SUBMISSION = 'Validation Submission',
  SSO_PROVISIONING = 'SSO & Provisioning',
  ANALYTICS = 'Analytics',
  OTHER = 'Other'
}

export const ModuleOrder: Record<ModuleType, number> = {
  [ModuleType.DISBURSEMENTS]: 1,
  [ModuleType.GRANTS]: 2,
  [ModuleType.WORKPLACE_GIVING]: 3,
  [ModuleType.VERIFICATIONS_INDIVIDUAL_API]: 4,
  [ModuleType.VALIDATION_SUBMISSION]: 5,
  [ModuleType.SSO_PROVISIONING]: 6,
  [ModuleType.ANALYTICS]: 7,
  [ModuleType.OTHER]: 8
}

export const rowModuleInfo = [
  {
    title: moduleTitles.DONATION_API,
    name: PartnerScopes.Donation,
    logoComponent: <img width="96px" height="108px" alt="donation logo" src={DonationLogo} />,
    active: false,
    type: ModuleType.DISBURSEMENTS
  },
  {
    title: moduleTitles.DONATION_MATCHING,
    name: PartnerScopes.DonationMatching,
    logoComponent: (
      <img width="96px" height="108px" alt="donation matching logo" className={styles.filterBlue} src={DonationLogo} />
    ),
    active: false,
    type: ModuleType.DISBURSEMENTS
  },
  {
    title: moduleTitles.OFF_PLATFORM_MATCHING,
    name: PartnerScopes.OffPlatformMatching,
    logoComponent: (
      <img width="96px" height="108px" alt="donation matching logo" className={styles.filterBlue} src={DonationLogo} />
    ),
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.DONATION_WALLET,
    name: PartnerScopes.DonationWallet,
    logoComponent: (
      <img width="96px" height="108px" alt="donation matching logo" className={styles.filterGreen} src={DonationLogo} />
    ),
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.DONATION_SESSION_API,
    name: PartnerScopes.DonationSession,
    logoComponent: <img width="96px" height="108px" alt="donation session logo" src={DonationSessionLogo} />,
    active: false,
    type: ModuleType.DISBURSEMENTS
  },
  {
    title: moduleTitles.DONATION_LINK,
    name: PartnerScopes.DonationLink,
    logoComponent: (
      <img
        width="96px"
        height="108px"
        alt="donation link logo"
        className={styles.filterGreen}
        src={DonationSessionLogo}
      />
    ),
    active: false,
    type: ModuleType.DISBURSEMENTS
  },
  {
    title: moduleTitles.WORKPLACE_GIVING,
    name: PartnerScopes.WorkplaceGiving,
    logoComponent: (
      <img
        width="96px"
        height="108px"
        alt="workplace giving logo"
        className={styles.filterBlue}
        src={DonationSessionLogo}
      />
    ),
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.PAYROLL_DONATION,
    name: PartnerScopes.PayrollDonation,
    logoComponent: (
      <img
        width="96px"
        height="108px"
        alt="payroll donation logo"
        className={styles.filterGreen}
        src={DonationSessionLogo}
      />
    ),
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.GIVING_CAMPAIGN,
    name: PartnerScopes.GivingCampaign,
    logoComponent: <img width="96px" height="108px" alt="giving campaign logo" src={DonationSessionLogo} />,
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.GIVING_AI,
    name: PartnerScopes.GivingAi,
    logoComponent: (
      <img width="96px" height="108px" alt="giving ai logo" className={styles.filterOrange} src={DonationSessionLogo} />
    ),
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.ORGANISATION_API,
    name: PartnerScopes.Organisation,
    logoComponent: <img width="96px" height="108px" alt="organisation logo" src={OrganisationLogo} />,
    active: false,
    type: ModuleType.OTHER
  },
  {
    title: moduleTitles.ORGANISATION_LOOKUP_API,
    name: PartnerScopes.OrganisationLookup,
    logoComponent: (
      <img
        width="96px"
        height="108px"
        alt="organisation lookup logo"
        className={styles.filterBlue}
        src={OrganisationLogo}
      />
    ),
    active: false,
    type: ModuleType.OTHER
  },
  {
    title: moduleTitles.MONETARY_DONATION_VERIFICATION,
    name: PartnerScopes.MonetaryDonationVerification,
    logoComponent: (
      <img width="96px" height="108px" alt="monetary donation verification logo" src={MonetaryVerificationLogo} />
    ),
    active: false,
    type: ModuleType.OTHER
  },
  {
    title: moduleTitles.VALIDATION_REQUEST_API,
    name: PartnerScopes.ValidationRequest,
    logoComponent: <img width="96px" height="108px" alt="validation logo" src={ValidationRequestLogo} />,
    active: false,
    type: ModuleType.VERIFICATIONS_INDIVIDUAL_API
  },
  {
    title: moduleTitles.WEBHOOK_SUBSCRIPTION_API,
    name: PartnerScopes.WebhookSubscription,
    logoComponent: <img width="96px" height="108px" alt="webhook subscription logo" src={WebhookSubscriptionLogo} />,
    active: false,
    type: ModuleType.OTHER
  },
  {
    title: moduleTitles.AGENT_VERIFICATION_API,
    name: PartnerScopes.AgentVerification,
    logoComponent: <img width="96px" height="108px" alt="agent verification logo" src={AgentVerificationLogo} />,
    active: false,
    type: ModuleType.VERIFICATIONS_INDIVIDUAL_API
  },
  {
    title: moduleTitles.ACTIVITY_CHECK_API,
    name: PartnerScopes.ActivityCheck,
    logoComponent: <img width="96px" height="108px" alt="activity check logo" src={ActivityCheckLogo} />,
    active: false,
    type: ModuleType.VERIFICATIONS_INDIVIDUAL_API
  },
  {
    title: moduleTitles.MONITORING_SUBSCRIPTION_API,
    name: PartnerScopes.MonitoringSubscription,
    logoComponent: (
      <img width="96px" height="108px" alt="monitoring subscription logo" src={MonitoringSubscriptionLogo} />
    ),
    active: false,
    type: ModuleType.VERIFICATIONS_INDIVIDUAL_API
  },
  {
    title: moduleTitles.ELIGIBILITY_SUBSCRIPTION_API,
    name: PartnerScopes.EligibilitySubscription,
    logoComponent: (
      <img width="96px" height="108px" alt="eligibility subscription logo" src={EligibilitySubscriptionLogo} />
    ),
    active: false,
    type: ModuleType.VERIFICATIONS_INDIVIDUAL_API
  },
  {
    title: moduleTitles.VALIDATION_INVITE_API,
    name: PartnerScopes.ValidationInvite,
    logoComponent: <img width="96px" height="108px" alt="validation invite logo" src={ValidationInviteLogo} />,
    active: false,
    type: ModuleType.VALIDATION_SUBMISSION
  },
  {
    title: moduleTitles.CODE_REDEMPTION_API,
    name: PartnerScopes.CodeRedemption,
    logoComponent: <img width="96px" height="108px" alt="code redemption logo" src={CodeRedemptionLogo} />,
    active: false,
    type: ModuleType.VALIDATION_SUBMISSION
  },
  {
    title: moduleTitles.SSO,
    name: PartnerScopes.SingleSignOn,
    logoComponent: <img width="96px" height="108px" alt="single sign-on" src={SSO} />,
    active: false,
    type: ModuleType.SSO_PROVISIONING
  },
  {
    title: moduleTitles.SSO_NOT_STRICT,
    name: PartnerScopes.SingleSignOnNotStrict,
    logoComponent: <img width="96px" height="108px" alt="single sign-on" className={styles.filterBlue} src={SSO} />,
    active: false,
    type: ModuleType.SSO_PROVISIONING
  },
  {
    title: moduleTitles.SINGLE_VALIDATION_SUBMISSION,
    name: PartnerScopes.SingleValidationSubmission,
    logoComponent: (
      <img width="96px" height="108px" alt="single validations submission" src={SingleValidationSubmissionLogo} />
    ),
    active: false,
    type: ModuleType.VALIDATION_SUBMISSION
  },
  {
    title: moduleTitles.VOLUNTEERING,
    name: PartnerScopes.Volunteering,
    logoComponent: (
      <img width="96px" height="108px" alt="donation logo" className={styles.filterBlue} src={DonationLogo} />
    ),
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.SLACK,
    name: PartnerScopes.Slack,
    logoComponent: <img width="96px" height="108px" alt="donation logo" className={styles.filterGreen} src={SSO} />,
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.GAMIFICATION,
    name: PartnerScopes.Gamification,
    logoComponent: (
      <img
        width="96px"
        height="108px"
        alt="gamification logo"
        className={styles.filterBlue}
        src={MonitoringSubscriptionLogo}
      />
    ),
    active: false,
    type: ModuleType.WORKPLACE_GIVING
  },
  {
    title: moduleTitles.SCIM_API,
    name: PartnerScopes.ScimApi,
    logoComponent: <img width="96px" height="108px" alt="scim logo" src={ScimLogo} />,
    active: false,
    type: ModuleType.SSO_PROVISIONING
  },
  {
    title: moduleTitles.GRANTS,
    name: PartnerScopes.Grants,
    logoComponent: <img width="96px" height="108px" alt="grants logo" src={GrantsLogo} />,
    active: false,
    type: ModuleType.GRANTS
  },
  {
    title: moduleTitles.PARTNER_INSIGHTS,
    name: PartnerScopes.PartnerInsights,
    logoComponent: <img width="96px" height="108px" alt="partner insights logo" src={PartnerInsightsLogo} />,
    active: false,
    type: ModuleType.ANALYTICS
  }
]
